import Icon from 'components/UI/Icon';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const chevronRight = require('theme/icons/chevron-right-tall.svg');
import './CheckoutChangeCardButton.scss';
function CheckoutChangeCardButton() {
    const { t } = useTranslation();
    return (React.createElement(NavLink, { to: "/checkout/payment", className: "change-payment-card-button" },
        React.createElement("span", null, t('checkoutCheckoutUseOtherCard')),
        React.createElement(Icon, { svg: chevronRight, className: "change-payment-card-button__icon" })));
}
export default CheckoutChangeCardButton;
